import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PageTitle from "../../layouts/PageTitle";
import { fetchAllMenus } from "../../../services/MenuService";
import MenusList from "./menusList";
import "../../../i18n";
import { useTranslation } from "react-i18next";
import "./Menu.css";
import "../Dashboard/kitchenLuxe.css";

const Menu = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [menus, setMenus] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const loadMenus = async () => {
    try {
      const data = await fetchAllMenus();
      if (data) {
        const archivedMenus = data.filter((menu) => menu.isArchived === false);
        setMenus(archivedMenus);
      }
    } catch (err) {
      console.error("Error loading menus", err);
    }
  };

  useEffect(() => {
    loadMenus();
  }, []);

  return (
    <>
      <div className="kitchen-page" data-tour="tour-page-menus">
        <PageTitle activeMenu={t("menus")} motherMenu={t("cms")} />
        <div className="kitchen-toolbar">
          <div className="kitchen-toolbar__search">
            <input
              type="text"
              className="form-control"
              placeholder={t("searchByTitle")}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <div className="kitchen-toolbar__actions">
            <button
              type="button"
              className="kitchen-toolbar__add"
              onClick={() => navigate("/add-menu")}
            >
              <i className="fas fa-plus" aria-hidden={true} />
              {t("createNewMenu")}
            </button>
          </div>
        </div>
        <MenusList menusResponse={menus} searchTerm={searchTerm} />
      </div>
    </>
  );
};

export default Menu;
